import React from "react";
import {
  Drawer,
  Button,
  Input,
  Form,
  Table,
  Row,
  Col,
  notification,
  Popconfirm,
  Select,
  Spin,
} from "antd";
import { Rose } from "@ant-design/charts";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import { designation, contacts, employeeRate } from "../../../constants/url";

class EmployeeRate extends React.Component {
  _isMounted = false;
  state = {
    editIsVisible: true,
    drawerIsVisible: false,
    editFormFields: [],
    designationData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    employeeData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    tableData: {
      list: [],
      loading: true,
    },
  };

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 80,
    },

    {
      title: "Contact",
      dataIndex: ["Contact", "ContactName"],
      key: "ContactName",
      align: "center",
    },
    {
      title: "Rate/Hour",
      dataIndex: "RatePerHour",
      key: "RatePerHour",
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 100,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              hidden={!this.state.editIsVisible}
              style={{ color: "#1890ff" }}
              onClick={() => {
                /**
                 * hide edit button because fetching data from backend might take
                 * a while. so prevent user from multi-clicking the edit button.
                 */
                this.setState({ editIsVisible: false });
                axiosInstance
                  .get(
                    // find the employee's designation
                    contacts +
                      "?ContactCategoryID=1&ContactID=" +
                      item.ContactID
                  )
                  .then((res) => {
                    if (res.data.success) {
                      let theEmployee = res.data.message.rows[0] || {};
                      if (theEmployee.DesignationID) {
                        axiosInstance
                          .get(
                            // find all employees for the designation
                            contacts +
                              "?ContactCategoryID=1&DesignationID=" +
                              theEmployee.DesignationID
                          )
                          .then((res) => {
                            if (res.data.success) {
                              let state = this.state;
                              const tempList = [];
                              tempList.push({
                                name: "ID",
                                value: item.ID,
                              });
                              tempList.push({
                                name: "RatePerHour",
                                value: item.RatePerHour,
                              });
                              state.editFormFields = tempList;
                              state.drawerIsVisible = true;
                              state.editIsVisible = true;
                              state.employeeData = {
                                list: res.data.message.rows,
                                selectedIndex: null,
                                selectedValue: null,
                              };
                              state.designationData.list.map((desig, index) => {
                                if (
                                  // select the matching designation
                                  desig.DesignationID ===
                                  theEmployee.DesignationID
                                ) {
                                  tempList.push({
                                    name: "Designation",
                                    value:
                                      "designation-" +
                                      index +
                                      "-" +
                                      desig.UserName,
                                  });
                                }
                                return desig;
                              });
                              state.employeeData.list.map((employee, index) => {
                                // select the matching employee
                                if (employee.ContactID === item.ContactID) {
                                  tempList.push({
                                    name: "ContactID",
                                    value:
                                      "employee-" +
                                      index +
                                      "-" +
                                      employee.ContactName,
                                  });
                                }
                                return employee;
                              });
                              this.setState(state);
                            } else this.setState({ editIsVisible: true });
                          })
                          .catch(() => {
                            this.setState({ editIsVisible: true });
                          });
                      }
                    }
                    this.setState({ editIsVisible: true });
                  })
                  .catch(() => {
                    this.setState({ editIsVisible: true });
                  });
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={() => {
                axiosInstance
                  .delete(
                    employeeRate + "/" + item.ContactID + "/" + item.RatePerHour
                  )
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.getInitialState().then((st) => {
                      this.resetFields();
                      this.setState(st);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  formRef = null;

  resetFields = () => {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  };

  getInitialState = async (drawerIsVisible) => {
    let state = {
      editIsVisible: true,
      drawerIsVisible: drawerIsVisible || false,
      editFormFields: [],
      designationData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      employeeData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      tableData: {
        list: this.state.tableData.list,
        loading: false,
      },
    };
    await axiosInstance
      .get(designation)
      .then((res) => {
        if (res.data.success) state.designationData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(employeeRate)
      .then((res) => {
        if (res.data.success) {
          state.tableData.list = res.data.message
            .map((data, index) => {
              data.SN = index + 1;
              data.key = index;
              data.RatePerHour = data.RatePerHour || 0;
              data.Employee = (data.Contact || {}).ContactName;
              return data;
            })
            .filter((rate) => rate.Contact);
        }
      })
      .catch(() => {});

    return state;
  };

  onCreateNew = (drawerIsVisible = false) => {
    return this.formRef
      .validateFields()
      .then(async (values) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: true },
        });
        (this.state.editFormFields.length
          ? axiosInstance.put(employeeRate, {
              ID: values.ID,
              ContactID:
                this.state.employeeData.list[values.ContactID.split("-")[1]]
                  .ContactID,
              RatePerHour: values.RatePerHour,
            })
          : axiosInstance.post(employeeRate, {
              ContactID:
                this.state.employeeData.list[values.ContactID.split("-")[1]]
                  .ContactID,
              RatePerHour: values.RatePerHour,
            })
        )
          .then((res) => {
            if (res && res.data.success) {
              notification.success({
                duration: 3,
                message: "Success",
                description: res.data.message || "Done!",
              });
              this.getInitialState(drawerIsVisible).then((st) => {
                this.resetFields();
                this.setState(st);
              });
            } else
              notification.error({
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      })
      .catch(() => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: false },
        });
      });
  };

  onChange = (value) => {
    let theIndex = value.split("-")[1];
    let theValue = value.split("-")[2];
    switch (value.split("-")[0]) {
      case "designation":
        this.setState(
          {
            designationData: {
              list: this.state.designationData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
          },
          () =>
            axiosInstance
              .get(
                contacts +
                  "?ContactCategoryID=1&DesignationID=" +
                  this.state.designationData.list[
                    this.state.designationData.selectedIndex
                  ].DesignationID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    employeeData: {
                      list: res.data.message.rows,
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "employee":
        this.setState({
          employeeData: {
            list: this.state.employeeData.list,
            selectedIndex: theIndex,
            selectedValue: theValue,
          },
        });
        break;
      default:
        break;
    }
  };

  onReset = () => {
    this.getInitialState().then((st) => this.setState(st));
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="New Employee Rates"
          placement="right"
          closable={false}
          onClose={() => {
            this.resetFields();
            this.setState({ editFormFields: [], drawerIsVisible: false });
          }}
          visible={this.state.drawerIsVisible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                type="primary"
                style={{ borderRadius: 20 }}
              >
                {this.state.editFormFields.length ? "Save" : "Create"}
              </Button>
              {!this.state.editFormFields.length ? (
                <Button
                  style={{ borderRadius: 20 }}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button
                style={{ borderRadius: 20 }}
                onClick={() => {
                  this.resetFields();
                  this.setState({
                    editFormFields: [],
                    drawerIsVisible: this.state.editFormFields.length > 0,
                  });
                }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <Form
            requiredMark
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
          >
            <Form.Item
              key="ID"
              name="ID"
              label="ID"
              labelAlign="left"
              labelCol={{ span: 7 }}
              hidden
            >
              <Input disabled></Input>
            </Form.Item>
            <Form.Item
              key="Designation"
              name="Designation"
              label="Designation"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: true, message: "Please select designation" }]}
            >
              <Select
                showSearch
                placeholder="Select a designation"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={this.state.designationData.selectedValue}
              >
                {this.state.designationData.list.map((desig, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"designation-" + index + "-" + desig.UserName}
                    >
                      {desig.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="ContactID"
              name="ContactID"
              label="Contact"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: true, message: "Please select employee" }]}
            >
              <Select
                showSearch
                placeholder="Select a employee"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={this.state.employeeData.selectedValue}
              >
                {this.state.employeeData.list.map((employee, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"employee-" + index + "-" + employee.ContactName}
                    >
                      {employee.ContactName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="RatePerHour"
              name="RatePerHour"
              label="RatePerHour"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: true, message: "Please enter rate" }]}
            >
              <Input type="number"></Input>
            </Form.Item>
          </Form>
        </Drawer>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Employee Rate</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={() => {
                this.setState({ drawerIsVisible: true });
              }}
              style={{ borderRadius: 20 }}
            >
              New
            </Button>
          </Col>
        </Row>
        <Spin
          spinning={this.state.tableData.loading}
          tip="fetching and populating data..."
        >
          <Row gutter={48} style={{ paddingLeft: 10, paddingRight: 10 }}>
            {this.state.tableData.list.length ? (
              <>
                <Col span={12} xs={24} sm={24} md={8} lg={8}>
                  <Row>
                    <Col
                      span={24}
                      style={{
                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                        transition: "0.3s",
                        borderRadius: 20,
                        width: "100%",
                        padding: 10,
                      }}
                    >
                      <Rose
                        {...{
                          data: this.state.tableData.list.map((item) => {
                            item.RatePerHour = item.RatePerHour || 0;
                            return item;
                          }),
                          xField: "Employee",
                          yField: "RatePerHour",
                          seriesField: "Employee",
                          label: false,
                          tooltip: {
                            formatter: (datum) => {
                              return {
                                name: "Rate/Hour: ",
                                value: datum.RatePerHour,
                              };
                            },
                            showContent: true,
                          },
                          // (innerHeight-headerFooter-viewSearchRow)/2-marginTop-for-Column
                          height: (window.innerHeight - 98 - 50) / 2,
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={0}
                  xs={24}
                  sm={24}
                  md={0}
                  lg={0}
                  style={{ marginTop: 10 }}
                ></Col>
              </>
            ) : null}
            <Col
              {...(this.state.tableData.list.length
                ? { span: 12, xs: 24, sm: 24, md: 16, lg: 16 }
                : { span: 24 })}
            >
              <Table
                // loading={this.state.tableData.loading}
                dataSource={this.state.tableData.list}
                columns={this.columns}
                scroll={{ y: window.innerHeight - 290 }}
                pagination={{
                  size: "small",
                  disabled: false,
                  defaultPageSize: 20,
                  showQuickJumper: true,
                  showSizeChanger: true,
                  total: this.state.tableData.list.length,
                }}
                style={{
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  borderRadius: 20,
                  width: "100%",
                }}
              ></Table>
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

export default withRouter(EmployeeRate);
